export const faq = [
   {
      id: "collapseOne",
      question: " How does AI Zorox work?",
      ans: " Lorem ipsum dolor sit amet, consectetur adipisicing elit.Ad voluptate doloribus eos sunt labore ea enim voluptatem, sequi voluptas rem doloremque architecto. Libero, vero natus."
   },
   {
      id: "collapseOne",
      question: " How can i exchange AI token from app??",
      ans: " Lorem ipsum dolor sit amet, consectetur adipisicing elit.Ad voluptate doloribus eos sunt labore ea enim voluptatem, sequi voluptas rem doloremque architecto. Libero, vero natus."
   },
   {
      id: "collapseOne",
      question: " Best way to make a trading from AI market.",
      ans: " Lorem ipsum dolor sit amet, consectetur adipisicing elit.Ad voluptate doloribus eos sunt labore ea enim voluptatem, sequi voluptas rem doloremque architecto. Libero, vero natus."
   },
   {
      id: "collapseOne",
      question: " Create AI token wallet free with code?",
      ans: " Lorem ipsum dolor sit amet, consectetur adipisicing elit.Ad voluptate doloribus eos sunt labore ea enim voluptatem, sequi voluptas rem doloremque architecto. Libero, vero natus."
   },
   {
      id: "collapseOne",
      question: " Create AI token wallet free with code?",
      ans: " Lorem ipsum dolor sit amet, consectetur adipisicing elit.Ad voluptate doloribus eos sunt labore ea enim voluptatem, sequi voluptas rem doloremque architecto. Libero, vero natus."
   },
]